import state from './state';

// Getters
export default {
  mailUnread() {
    return state.unread;
  }
};
